import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FormGroup from 'features/shared/forms/components/FormGroup';
import { formatDate } from 'features/shared/helpers/Formatters';
import React from 'react';

interface Props {
  title: string;
  value: string | Date;
  valueType?: "string" | "date";
  visible: boolean;
  icon: IconProp;
}

const AdvanceDisabledInput = ({ title, value, valueType = "string", visible, icon }: Props) => {
  // helpers
  const getValue = ():string => {
    switch (valueType) {
      case "string":
        return String(value);
      case "date":
        return formatDate(value, {day: "2-digit", month: "2-digit", year: "numeric"})!;
      default:
        return String(value);
    }
  }

  // render
  return (
    <FormGroup
      labelText={title}
      visible={visible}
    >
      <div className="input-group">
        <div className="input-group-prepend">
          <div className="input-group-text text-muted">
            <FontAwesomeIcon icon={icon} />
          </div>
        </div>
        <input 
          className="form-control bg--white"
          value={getValue()} 
          disabled
          title={getValue()}
        />
      </div>
    </FormGroup>
  )
}

export default AdvanceDisabledInput;
